export const state = {
  title: "雅康高速光纤通信线路应急预警系统",
};
